import { Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import StyledBox from "../styled/styledBox";
import React from "react";

const WelcomeStepThree = (): React.JSX.Element => (
  <StyledBox>
    <Typography variant="h5" color="initial" sx={{ mb: 2, fontWeight: "bold" }}>
      Schritt 3.
    </Typography>

    <Typography
      variant="body1"
      color="primary"
      sx={{ mb: 2, fontWeight: "bold" }}
    >
      Komme ins Coaching
    </Typography>

    <Typography variant="body1" color="initial" sx={{ mb: 2 }}>
      Nutze die Terminbestätigung oder den Link, der am Tag des Termins hinter
      deinem gebuchten Termin erscheinen wird.
    </Typography>

    <Link
      to={"/appointments"}
      style={{
        textAlign: "center",
        width: "100%",
      }}
    >
      <Button fullWidth variant="contained" color="secondary">
        Meine Termine
      </Button>
    </Link>
  </StyledBox>
);

export default WelcomeStepThree;
